import React from "react";
import { motion } from "framer-motion";
import SectionHeader from "./SectionHeader";
import BrandStripe from "./BrandStripe";
import { TID } from "@/lib/testIds";

const strengths = [
  { value: "+1.0", name: "Beige",  desc: "Beginning clarity",     bg: "var(--ge-beige)",  fg: "var(--ge-navy)", ring: "var(--ge-navy)" },
  { value: "+1.5", name: "Yellow", desc: "Everyday focus",        bg: "var(--ge-yellow)", fg: "var(--ge-navy)", ring: "var(--ge-navy)" },
  { value: "+2.0", name: "Red",    desc: "Enhanced reading",      bg: "var(--ge-red)",    fg: "#ffffff",         ring: "#ffffff" },
  { value: "+2.5", name: "Green",  desc: "Strong visual support", bg: "var(--ge-green)",  fg: "#ffffff",         ring: "#ffffff" },
  { value: "+3.0", name: "Navy",   desc: "Maximum magnification", bg: "var(--ge-navy)",   fg: "#ffffff",         ring: "#ffffff" },
];

export const StrengthSystem = () => {
  return (
    <section
      id="strengths"
      data-testid={TID.strength.root}
      className="relative bg-[color:var(--ge-green)] text-white py-24 md:py-32 overflow-hidden"
    >
      <div className="ge-container">
        <SectionHeader
          kicker="The Colour System"
          title={<>Each colour is a<br />different <span style={{ color: "var(--ge-yellow)" }}>strength</span>.</>}
          subtitle="Simple to find. Easy to remember. Every Good Eyes frame is colour-coded so choosing the right strength is just picking your favourite hue."
          tone="light"
        />

        <div className="mt-14 md:mt-20 flex flex-col gap-3 md:gap-4">
          {strengths.map((s, i) => (
            <motion.div
              key={s.value}
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="flex items-center gap-4 md:gap-8 rounded-full pr-6 md:pr-8 pl-2 md:pl-3 py-2 md:py-3 text-left"
              style={{ background: s.bg, color: s.fg }}
              data-testid={TID.strength.swatch(s.value)}
            >
              <span
                className="shrink-0 inline-flex items-center justify-center rounded-full font-bold text-lg md:text-xl h-14 w-14 md:h-20 md:w-20 bg-white/95"
                style={{ color: "var(--ge-navy)" }}
              >
                {s.value}
              </span>
              <span className="flex-1 grid grid-cols-1 md:grid-cols-2 items-center gap-3">
                <span className="tight-cap font-bold text-3xl md:text-5xl leading-none">
                  {s.name}
                </span>
                <span className="text-sm md:text-lg font-medium opacity-90 md:border-l md:border-white/30 md:pl-6">
                  {s.desc}
                </span>
              </span>
            </motion.div>
          ))}
        </div>

        <div className="mt-20 md:mt-28">
          <h3 className="tight-cap font-bold leading-[0.95] text-[clamp(1.8rem,4vw,3.2rem)] text-white uppercase">
            One colour. One strength.<br />
            <span style={{ color: "var(--ge-yellow)" }}>One less thing</span> to think about.
          </h3>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0">
        <BrandStripe height={22} />
      </div>
    </section>
  );
};

export default StrengthSystem;
